<script setup lang="ts">
import { computed, ref } from "vue";
const page = usePage().value;

const bagTransfer = computed(() => page?.bagTransfer ?? []);
const selectedTrekRoute = ref("");

const trekRoutes = computed(() => {
  const routes = bagTransfer.value.map((item) => item.trek_route);
  return [...new Set(routes)];
});

const filteredBagTransfer = computed(() => {
  if (!selectedTrekRoute.value) return [];
  return bagTransfer.value.filter(
    (item) => item.trek_route === selectedTrekRoute.value,
  );
});
</script>

<template>
  <section class="bag-transfer-table">
    <h2>Bag &amp; Airport Transfer Details</h2>
    <h4>Select a trek route to view bag transfer prices:</h4>
    <select v-model="selectedTrekRoute">
      <option value="" disabled selected>Select a trek route</option>
      <option v-for="route in trekRoutes" :key="route" :value="route">
        {{ route }}
      </option>
    </select>
    <!-- Table header -->
    <div v-if="selectedTrekRoute" class="table-row table-header">
      <div class="table-cell">
        <span v-if="selectedTrekRoute">{{ selectedTrekRoute }}</span
        ><span v-else>Trek Package</span>
      </div>
      <div class="table-cell">Group Size</div>
      <div class="table-cell">Bag Transfer Cost</div>
    </div>

    <!-- Table rows -->
    <div
      v-for="(item, index) in filteredBagTransfer"
      :key="index"
      class="table-row"
    >
      <div class="table-cell full-width" data-label="Trek Package">
        <p>{{ item.trek_package }}</p>
      </div>
      <div class="table-subrow">
        <div class="table-cell" data-label="Group Size">
          <span v-html="item.group_size"></span>
        </div>
        <div class="table-cell" data-label="Bag Transfer Cost">
          <span v-html="item.cost"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.bag-transfer-table {
  margin: 2rem 0;
  width: 100%;
  font-family: sans-serif;
}
.bag-transfer-table select {
  padding: 0.5rem;
  font-size: 0.9rem;
  margin-bottom: 20px;
  width: 200px;
}
.table-row {
  display: flex;
  border-bottom: 1px solid #ddd;
  padding: 0.75rem 0;
}
.table-subrow {
  display: flex;
  flex: 2;
}

/* Ensure rows lay out in 3 columns on desktop */
.table-row {
  display: flex;
  align-items: stretch;
}
.full-width {
  flex: 1;
}

.table-row:nth-child(even) {
  background: #e0dfdf;
}
.table-row.table-header {
  font-weight: bold;
  background-color: #f5f5f5;
  border-top: 2px solid #333;
  background: #003149;
}
.table-row.table-header {
  color: #fff;
}
.table-cell {
  flex: 1;
  padding: 0 1rem;
  word-break: break-word;
  display: flex;
  align-items: center;
}
.table-cell p {
  margin: 0 !important;
}
.table-cell span p {
  margin: 0 !important;
}

@media (max-width: 991px) {
  .table-header {
    display: none !important;
  }

  .table-row {
    flex-direction: column;
    border-bottom: 1px solid #ccc;
    padding: 1rem;
    background: #f9f9f9;
  }

  .table-subrow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 0.5rem;
  }

  .table-cell {
    flex: 1;
    padding: 0.5rem 0;
    position: relative;
    display: block;
  }

  .table-cell::before {
    content: attr(data-label);
    font-weight: bold;
    display: block;
    color: #333;
    margin-bottom: 0.25rem;
  }
}
</style>
